import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { AppConfigurationService } from '../app-configuration.service'
import { Observable } from 'rxjs'
import { catchError, map, retry } from 'rxjs/operators'
import { SharedService } from '../shared/shared.service'
import { ICustomB2BUnitNode } from '../../models/interface/org-unit.interface'

@Injectable({
  providedIn: 'root'
})
export class AccountSummaryService {
  constructor(
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private sharedService: SharedService
  ) {}

  public getOrgUnits(): Observable<any> {
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/users/current/orgUnitsRootNodeTree`
    return this.http.get<any>(url).pipe(retry(1), catchError(this.sharedService.handleError))
  }

  public getOrgUnitDetail(id: string): Observable<any> {
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/users/current/orgUnits/${id}`
    return this.http.get<any>(url).pipe(retry(1), catchError(this.sharedService.handleError))
  }

  public getAllOrgUnits(): Observable<any> {
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/users/current/allOrgUnitNodes`
    return this.http.get<any>(url).pipe(
      map((res) => {
        return res.unitNodes.filter((item) => {
          return item.active
        })
      }),
      map((res: ICustomB2BUnitNode[]) => {
        return res.map((item) => {
          return {
            label: item.name,
            value: item.id,
            selected: item.selected
          }
        })
      }),
      retry(1),
      catchError(this.sharedService.handleError)
    )
  }

  public changeOrgUnits(orgUnit: string): Observable<any> {
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/users/current/switchB2BUnit/${orgUnit}`
    return this.http.get<any>(url).pipe(retry(1), catchError(this.sharedService.handleError))
  }
}
